<template>
    <v-select 
       :value="selected_eventstatus" 
       v-bind:items="eventstatuscodes"
       item-value="code" 
       item-text="description" 
       :label="label"
       dense 
       :clearable="selection_clearable"
       :disabled="disabled"
       @change="updateData">
    </v-select>
</template>

<script>
export default {
    props: {
        selected_eventstatus: String,
        label: String,
        field: {
            default: 'eventstatuscode',
            required: true,
        },
        selection_clearable:{
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }         
    },
    data() {
        return {
            eventstatuscodes: [],
        }
    },
    created() {
        this.getCalculationInfo();
    },
    methods: {
        getCalculationInfo() {
            this.$axios
                .post("ares/json/ares/huov/hosm/getSmst.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getSmst"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        console.log('getSmst', res.data.getSmst);
                        this.eventstatuscodes = res.data.getSmst;
                    }
                })
        },
        updateData(v){
            this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v })
        }
    }
}
</script>

<style scoped>

</style>